module.exports = __webpack_public_path__ + "img/publications6_gecell.93052221.jpg";